import type React from 'react';
import { RatingTooltip } from './RatingTooltip';
import { StarRating } from './StarRating';

export interface StarRatingAboveTooltipBelowLayoutProps {
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
  hideNumber?: boolean;
  align?: 'start' | 'center' | 'end';
}

export function StarRatingAboveTooltipBelowLayout({
  reviewLink,
  starRating,
  starRatingTooltip,
  hideNumber = false,
  align = 'start',
}: StarRatingAboveTooltipBelowLayoutProps): React.JSX.Element | string {
  if (!starRating) return 'Not yet rated';

  const alignClass =
    align === 'center' ? 'items-center' : align === 'end' ? 'items-end' : 'items-start';

  return (
    <div className={`flex flex-col ${alignClass}`} data-testid="rating-component">
      <div>
        {/* 13px: legacy StarRatingAboveTooltipBelowLayout.tsx responsive xs font size. */}
        <span className="typography-text inline-block whitespace-nowrap text-[13px] md:text-base">
          {reviewLink ? (
            <a href={reviewLink} rel="noopener noreferrer" target="_blank">
              NerdWallet rating{' '}
            </a>
          ) : (
            <>NerdWallet rating </>
          )}
          {starRatingTooltip && <RatingTooltip starRatingTooltip={starRatingTooltip} />}
        </span>
      </div>
      <div className="flex gap-1">
        <StarRating
          className="mt-[2px] mr-2 md:[--star-rating-size:16px]"
          gap="5px"
          size="15px"
          value={starRating}
        />
        {!hideNumber && starRating !== 0 && (
          <span className="mr-1 inline-block">{starRating.toFixed(1)}</span>
        )}
      </div>
    </div>
  );
}
